import {getCookie} from "../util/cookie";

class SessionTimeoutModalHandler {

    /* fields
    modalEl
    sessionCookieName
    cookieExpireMinutes
    lastCookieValue
    cookieCheckInterval
    finalCleanupTimeout
     */

    constructor(options = {}) {
        if (options.modalEl && options.sessionCookieName && options.cookieExpireMinutes) {
            this.modalEl = options.modalEl;
            this.sessionCookieName = options.sessionCookieName;
            this.cookieExpireMinutes = options.cookieExpireMinutes;
            this.lastCookieValue = null;
            this.modalTriggerTimeout = null;
            this.finalCleanupTimeout = null;

            // lets show the modal 10 mins before expire minutes
            this.modalTriggerMinutesBeforeSessionExpire = 10;

            this.initConfirmButton();

            this.start();
        }
    }

    initConfirmButton() {
        this.modalEl.find("#confirm_button").click(function () {
            window.location.reload();
        });
    }

    start() {
        this.cookieCheckInterval = setInterval(this.resetModalTriggerTimeoutIfCookieRefreshed.bind(this), 1000);
    }

    stopProcessAndShowLoggedOutModal() {
        // clear all intervals and timeouts
        clearInterval(this.cookieCheckInterval);
        clearTimeout(this.modalTriggerTimeout);
        clearTimeout(this.finalCleanupTimeout);

        this.modalEl.modal('open');
        this.modalEl.find(".modal-content").html("<p>You are logged out. Do you want to reload?</p>");
    }

    resetModalTriggerTimeoutIfCookieRefreshed() {
        // if session cookie is empty, it means user is already logged out somehow before we can warn them
        // e.g. user's computer might have went to sleep which caused our js timer to pause, but the user actually was logged out on the backend server
        if (this.sessionCookieIsEmpty()) {
            this.stopProcessAndShowLoggedOutModal();
            return;
        }

        if (this.checkCookieChanged()) {
            // if warning was triggered already but session has not expired yet, then we will close the warning
            if (this.modalEl.hasClass('open')) {
                this.modalEl.modal('close');
            }

            this.resetModalTriggerTimeout();
        }
    }

    checkCookieChanged() {
        let newCookieValue = getCookie(this.sessionCookieName);
        if (newCookieValue !== this.lastCookieValue) {
            this.lastCookieValue = newCookieValue;
            return true;
        }
        return false;
    }

    sessionCookieIsEmpty() {
        return getCookie(this.sessionCookieName).length < 1;
    }

    resetModalTriggerTimeout() {
        if (this.modalTriggerTimeout) {
            clearTimeout(this.modalTriggerTimeout);
        }
        if (this.finalCleanupTimeout) {
            clearTimeout(this.finalCleanupTimeout);
        }
        this.modalTriggerTimeout = setTimeout(this.triggerModal.bind(this), this.waitTimeForModal.bind(this)());
    }

    waitTimeForModal() {
        // if value negative 0 will be returned
        return Math.max((this.cookieExpireMinutes - this.modalTriggerMinutesBeforeSessionExpire) * 60000, 1)
    }

    triggerModal() {
        this.modalEl.modal('open');

        // user will be logged out in session time left(this.modalTriggerMinutesBeforeSessionExpire), if cookie is not changed then final cleanup timeout here
        this.setFinalCleanupTimeout();

    }

    setFinalCleanupTimeout() {
        this.finalCleanupTimeout = setTimeout(() => {
            this.modalEl.find(".modal-content").html("<p>You are logged out. Do you want to reload?</p>");

            // finally once the modal is active, we have warned them, work is done, stop the checks
            console.log('session checks stopped');
            // we will stop checking 2 mins before the session expires
            clearInterval(this.cookieCheckInterval);
        }, (this.modalTriggerMinutesBeforeSessionExpire - 2) * 60000);
    }
}

export default SessionTimeoutModalHandler;